export default __webpack_public_path__ + "static/media/nightSounds.a3fe09c9.wav";